import { axios, API } from './config';

export const floorplansAPI = {
  getAll: async (contractId) => {
    const params = contractId ? `?contract_id=${contractId}` : '';
    const response = await axios.get(`${API}/floorplans${params}`);
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`${API}/floorplans/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(`${API}/floorplans`, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API}/floorplans/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axios.delete(`${API}/floorplans/${id}`);
    return response.data;
  }
};
